module.exports = __webpack_public_path__ + "static/media/item_25_3.19f8a331.png";